export const AutoCheckFeedbackItemSourceFragment = gql`
  fragment AutoCheckFeedbackItemSourceFragment on AutoCheckFeedbackItemSource {
    id
    sourceType
    sourceFilePageNumber
    sourceFile {
      id
      name
    }
  }
`

export const AutoCheckFeedbackItemBaseFragment = gql`
  fragment AutoCheckFeedbackItemBaseFragment on AutoCheckFeedbackItemBase {
    id
    feedbackText
    severity
    sourceRuleType
    createdAt
    resolvedAt
  }
`

export const AutoCheckFeedbackItemFragment = gql`
  fragment AutoCheckFeedbackItemFragment on AutoCheckFeedbackItem {
    id
    createdAt
    feedbackText
    isAddedAsPlanReviewComment
    markedAsNotApplicableAt
    reasonWhyMarkedAsNotApplicable
    resolvedAt
    severity
    sourceRuleType
    status
    codeBookItem {
      ...CodeBookItemOptionFragment
    }
    markedAsNotApplicableByUser {
      ...UserDataFragment
    }
    resolvedByUser {
      ...UserDataFragment
    }
    sourceFile {
      ...AutoCheckFeedbackItemSourceFragment
    }
  }
`

export const AutoCheckExecutionFragment = gql`
  fragment AutoCheckExecutionFragment on AutoCheckExecution {
    id
    autoCheckFeedbackItems {
      ...AutoCheckFeedbackItemFragment
    }
  }
`

export const AutoCheckFeedbackUpdateFragment = gql`
  fragment AutoCheckFeedbackUpdateFragment on AutoCheckFeedbackUpdate {
    executionId
    isDone
    feedback {
      ...AutoCheckFeedbackItemBaseFragment
    }
  }
`
